<template>
  <div
    class="label-select"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="col-12 selected gdq-w-150px"
      :class="{open: open}"
      :style="{ overflowX: 'hidden', overflowY: 'hidden' }"
      @click="open = !open"
    >
      <span :style="{ background: '#'+selected.color }">&nbsp;&nbsp;&nbsp;&nbsp;</span>
      {{ selected.text }}
    </div>
    <div
      class="col-12 items px-0"
      :class="{selectHide: !open}"
    >
      <div
        class="col-12 item"
        v-for="option in options"
        :key="option.id"
        @click="selectOption(option)"
      >
        <span :style="{ background: '#'+option.color }">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelSelect',
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: {
        value: 0,
        text: this.placeholder,
        color: 'ffffff',
      },
      open: false
    };
  },
  mounted() {
    this.$emit('update:modelValue', 0);
  },
  methods: {
    selectOption(option) {
      this.selected = option;
      this.open = false;
      this.$emit('update:modelValue', Number(option.value));
    }
  }
};
</script>

<style scoped>
.label-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 36px;
  line-height: 36px;
}

.selected {
  position: relative;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #ced4da;
  color: black;
  padding-left: 8px;
  padding-right: 30px;
  cursor: pointer;
  user-select: none;
  height: calc(1.5em + 0.75rem + 2px);
}

.selected.open {
  border: 1px solid #ced4da;
  border-bottom: 0;
  border-radius: 4px 4px 0px 0px;
}

.selected:after {
  position: absolute;
  content: "";
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-color: #000 transparent transparent transparent;
}

.items {
  color: black;
  border-radius: 0px 0px 4px 4px;
  overflow: hidden;
  border-right: 1px solid #ced4da;
  border-left: 1px solid #ced4da;
  border-top: 1px solid #ced4da;
  border-bottom: 1px solid #ced4da;
  position: absolute;
  background-color: white;
  left: 14px;
  right: 0;
  z-index: 101;
}

.item {
  color: black;
  padding-left: 8px;
  cursor: pointer;
  user-select: none;
}

.item:hover {
  color: white;
  background-color: #0078d7;
}

.selectHide {
  display: none;
}
</style>
